<template lang="pug">
.swap-battery-card-info
  .main-title
    .text-stroke(:data-text="cardInfo.mainTitle") {{ cardInfo.mainTitle }}
  .card-info
    .card-content
      .use-tip(v-if="cardInfo.isAppOnly")
      .card-title {{ cardInfo.cardMainTitle }}
      .card-desc
        highlight-text(
          :text="cardInfo.cardSubTitle"
          :normalStyle="normalStyle"
          :highlightStyle="highlightStyle"
        )
        .card-use-attr {{ cardInfo.useTip }}
      .card-price(v-if="cardInfo.cardPrice")
        span 价值
        span.num {{ cardInfo.cardPrice }}
        span 元
  .bottom-desc(v-if="cardInfo && cardInfo.useDesc")
    .desc-item(v-for="desc in cardInfo.useDesc")
      highlight-text(
        :text="desc"
        :normalStyle="descNormalStyle"
        :highlightStyle="descHighlightStyle"
      )
</template>

<script>
import highlightText from '@/components/highlight-text.vue';

export default {
  name: 'SwapBatteryCardInfo',
  components: {
    highlightText,
  },
  props: {
    cardInfo: {
      type: Object,
      default: () => ({
        mainTitle: '',
        cardMainTitle: '',
        cardSubTitle: '',
        cardPrice: '',
        useTip: '',
        isAppOnly: false,
        useDesc: [],
      }),
    },
  },
  data() {
    return {
      normalStyle: {
        color: '#fff',
        fontSize: '0.126rem',
        fontWeight: 500,
        fontFamily: 'DINAlternate',
      },
      highlightStyle: {
        color: '#fff',
        fontSize: '0.25rem',
        fontWeight: 500,
        fontFamily: 'DINAlternate',
        marginRight: '0.04rem',
      },
      descHighlightStyle: {
        color: '#242729',
        fontSize: '0.12rem',
        fontWeight: 500,
      },
      descNormalStyle: {
        color: '#879099',
        fontSize: '0.12rem',
        fontWeight: 400,
      },
    };
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: 'AlimamaFangYuanTiVF';
  src: url('https://m.hellobike.com/6b503fe7_AlimamaFangYuanTiVF-Thin.ttf') format('truetype');
  font-style: normal;
  font-variation-settings: "wght" 700, "BEVL" 100;
}

.swap-battery-card-info {
  width: 3.35rem;
  border-radius: 0.2rem;
  background: url('https://m.hellobike.com/1d2d2159_Frame_3%20(1).png') no-repeat center/100% 100%;
  padding-bottom: 0.2rem;

  .main-title {
    font-size: 0.21rem;
    font-weight: 700;
    text-align: center;
    padding: 0.16rem 0 0.1rem;
    font-family: 'AlimamaFangYuanTiVF', sans-serif;

    .text-stroke {
      font-size: 0.21rem;
      font-weight: 700;
      position: relative;
      color: transparent;

      &::after {
        content: attr(data-text);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 1;
        color: #000;
      }

      &::before {
        content: attr(data-text);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 0;
        -webkit-text-stroke: 6px #fff;
        color: transparent;
      }
    }
  }

  .card-info {
    width: 3.12rem;
    height: 0.96rem;
    box-sizing: content-box;
    margin: 0 auto;
    padding: 0 0.09rem 0.19rem;
    background: url('https://m.hellobike.com/2210e352b2.png') no-repeat center/100% 100%;
    position: relative;

    .card-content {
      box-sizing: border-box;
      padding: 0.14rem 0.17rem 0;
      position: relative;
      height: 100%;

      .use-tip {
        position: absolute;
        top: 0;
        right: 0;
        width: 0.82rem;
        height: 0.2rem;
        transform: translateX(1px);
        background: url('https://m.hellobike.com/c07e0cdb_Group_1707483907.png') no-repeat center/100% 100%;
      }

      .card-title {
        font-size: 0.16rem;
        color: #fff;
        font-weight: 600;
        font-family: 'DINAlternate', sans-serif;
        letter-spacing: 0.008rem;
        padding-top: 0.04rem;
      }

      .card-desc {
        margin-top: 0.06rem;
        display: flex;
        align-items: baseline;

        .card-use-attr {
          font-size: 0.095rem;
          color: rgba(255, 255, 255, 0.7);
          font-weight: 400;
          margin-left: 0.05rem;
        }
      }

      .card-price {
        font-size: 0.12rem;
        color: rgba(255, 255, 255, 0.5);
        font-weight: 600;
        margin-top: 0.06rem;
        display: flex;
        align-items: baseline;
        position: absolute;
        right: 0.13rem;
        bottom: 0.1rem;

        .num {
          font-size: 0.18rem;
          font-weight: 700;
          font-family: 'DINAlternate', sans-serif;
        }
      }
    }
  }

  .bottom-desc {
    padding: 0 0.24rem 0;

    .desc-item {
      margin-bottom: 0.06rem;
    }
  }
}
</style>
